import React from "react";
import PropTypes from "prop-types";

import ModalGalleryPortal from "./ModalGalleryPortal";
import Gallery from "./Gallery";
import GalleryImage from "./GalleryImage";
import GalleryVideo from "./GalleryVideo";
import GalleryIframe from "./GalleryIframe";

export const ModalGallery = ({
  node,
  isOpened,
  isVisible,
  closeText,
  close,
  children,
  trigger,
  slides,
  thumbnails,
  ...otherProps
}) => {
  return (
    !isOpened && "",
    isOpened && (
      <ModalGalleryPortal
        node={node}
        isOpened={isOpened}
        isVisible={isVisible}
        closeText={closeText}
        close={close}
        trigger={trigger}
        {...otherProps}
      >
        <Gallery slides={slides} thumbnails={thumbnails} />
      </ModalGalleryPortal>
    )
  );
};

ModalGallery.propTypes = {
  node:
    typeof Element !== "undefined"
      ? PropTypes.instanceOf(Element)
      : PropTypes.number,
  isOpened: PropTypes.bool.isRequired,
  closeText: PropTypes.string,
  close: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  slides: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
  ).isRequired,
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    })
  ).isRequired,
  trigger: PropTypes.instanceOf(
    typeof Element === "undefined" ? () => {} : Element
  ),
};

ModalGallery.defaultProps = {
  node: typeof document === "undefined" ? null : document.body,
  closeText: "Schließen",
  close: null,
  children: null,
  trigger: null,
  isVisible: false,
};

ModalGallery.Image = GalleryImage;
ModalGallery.Video = GalleryVideo;
ModalGallery.Iframe = GalleryIframe;

ModalGallery.displayName = "ModalGallery";

export default ModalGallery;
